export default __webpack_public_path__ + "static/media/res-project-4.9f48487d.webp";